import React from 'react';

import cn from 'classnames';

import { ICommentMessage } from '@entities/message/model/types';
import { useToggleState } from '@shared/hooks';
import { Flex, Icon, UiButton, UiText } from '@shared/ui';
import { formatIsoDate } from '@widgets/Comments/lib/helpers';
import { useCommentsMainContext } from '@widgets/Comments/model';

import cls from './MessageItem.module.css';
import { MessageAttachments } from '../MessageAttachments';

interface IMessageItemProps {
    className?: string;
    messageData: ICommentMessage;
}
export const MessageItem = ({ className, messageData }: IMessageItemProps) => {
    const [isHovered, toggleHover] = useToggleState(false);
    const { openDeletePopup } = useCommentsMainContext();
    const messageTime = formatIsoDate(messageData?.datetime);

    const handleHover = () => {
        if (!messageData.isMine) return;
        if (!messageData.canDelete) return;
        toggleHover();
    };

    // const filteredAttachments = useMemo(
    //     () => ({
    //         imgAttachments: messageData?.images?.filter((attach) => isImg(attach.mimeType)),
    //         otherAttachments: messageData?.files?.filter((attach) => !isImg(attach.mimeType)),
    //     }),
    //     [messageData?.images, messageData?.files]
    // );

    return (
        <Flex
            gap={4}
            className={cn(cls.MessageItemContainer)}
            onMouseEnter={handleHover}
            onMouseLeave={handleHover}
            fullWidth
        >
            <Flex
                as="li"
                direction="column"
                className={cn(cls.MessageItem, messageData.isMine && cls.isYours, className)}
            >
                {messageData.isMine && isHovered && (
                    <UiButton
                        className={cls.DeleteCommentBtn}
                        variant="icon"
                        startIcon={<Icon iconName="taskDelete" />}
                        onClick={() => openDeletePopup(messageData.id)}
                    />
                )}

                <MessageAttachments
                    imgAttachments={messageData?.images}
                    otherAttachments={messageData?.files}
                />
                <Flex fullWidth className={cls.MessageItemInfo} direction="column" gap={12}>
                    <Flex fullWidth>
                        <UiText variant="mediumPlain">{messageData?.text}</UiText>
                    </Flex>
                    <Flex gap={8} justify="end" fullWidth>
                        {messageData.user && (
                            <UiText variant="mediumPlain">{messageData?.user?.name}</UiText>
                        )}
                        <UiText variant="mediumPlain">{messageTime}</UiText>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    );
};
